import { Modal, Button, Typography, Box, Snackbar, Alert, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { startOfMonth } from 'date-fns';
import enUS from 'date-fns/locale/en-US';
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { useDispatch, useSelector } from "react-redux";
import { generateShift } from "store/slice/shiftsSlice";
import ModalAbstract from "common/Modal/Modal";

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
};

const ShiftModal = ({
    isShiftModalOpen, 
    handleModalClose,
    dealerToReject
}) => {
    const dispatch = useDispatch();

    const studiosStore = useSelector((store) => store.studios);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');

    const [shiftTimeRange, setShiftTimeRange] = useState([
        {
            startDate: startOfMonth(new Date()),
            endDate: new Date(),
            key: 'selection'
        }
    ]);

    // State to store studio inputs
    
    
    const [studiosValues, setStudiosValues] = useState({
        // 2: 18,
        3: 5,
        4: 10,
        6: 2
    });

    useEffect(() => {
        const initialStudios = studiosStore?.studios.reduce((ac, studio) => {
            ac[studio.id] = 1;
            return ac;
        }, {})
      //  setStudiosValues(initialStudios)
    }, [studiosStore?.studios])
 
    const handleStudioChange = (id, value) => {
        setStudiosValues(prev => ({ ...prev, [id]: parseInt(value) }));
    };

    const handleGenerateClick = (isManual = false) => {

        dispatch(generateShift({
            studiosValues, 
            startDate: shiftTimeRange[0]?.startDate, 
            endDate: shiftTimeRange[0]?.endDate,
            isManual
        }))
        // setSnackbarMessage(`${dealerToReject?.name} has been rejected and a new shift has been generated.`);
        // setSnackbarSeverity('success');
        // setSnackbarOpen(true);
        // handleModalClose();
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') return;
        setSnackbarOpen(false);
    };
    return (
        <>
            <ModalAbstract
                open={isShiftModalOpen}
                onClose={handleModalClose}
            >
                <Typography id="modal-modal-title" variant="h6" component="h2" gutterBottom>
                    Generate shift
                </Typography>
                <DateRangePicker
                    ranges={shiftTimeRange}
                    onChange={item => setShiftTimeRange([item.selection])}
                    moveRangeOnFirstSelection={true}
                    direction="horizontal"
                    locale={enUS}
                />
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mt: 2 }}>
                
                    {studiosStore?.studios.map(({ id, name }) => {
                        return ((
                            <Box key={id} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', border: '1px solid #ddd', padding: 2, borderRadius: 1 }}>
                                <Typography>{name}</Typography>
                                <TextField 
                                    value={studiosValues[id] || ''} 
                                    onChange={(e) => handleStudioChange(id, e.target.value)} 
                                    placeholder="Enter value"
                                    variant="outlined"
                                    size="small"
                                />
                            </Box>
                        ))
                    })}
                </Box>

                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                    <Button variant="text" onClick={handleModalClose}>
                        Cancel
                    </Button>
                    <Button variant="contained" color="primary" onClick={()=> handleGenerateClick()}>
                        Generate
                    </Button>
                    <Button variant="contained" color="secondary" onClick={() => handleGenerateClick(true)} style={{ marginLeft: 8 }}>
                        Manual create
                    </Button>
                </Box>
            </ModalAbstract>
        </>
    );
};

export default ShiftModal;
